import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20warm%20golden%20and%20crimson%20fluid%20gradient%20background%20with%20soft%20flowing%20shapes%2C%20luxurious%20texture%2C%20elegant%20atmosphere%2C%20dark%20rich%20tones%20with%20golden%20accents%2C%20sophisticated%20modern%20feel%2C%20smooth%20curves%20and%20subtle%20light%20reflections%2C%20premium%20quality%20aesthetic&width=1800&height=620&seq=hero-bg-kaiyun-2026&orientation=landscape"
        alt="kaiyun com 官方平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55" />

      <div className="relative z-10 w-full px-4 md:px-6 text-center max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <i className="ri-shield-check-line text-accent-400 text-sm" />
          <span className="text-xs md:text-sm text-background-50/90 font-medium tracking-wide">
            {t('site.tagline')}
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5 tracking-tight">
          {t('hero.title')}
        </h1>

        <p className="text-sm md:text-base text-background-50/75 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer transform hover:scale-105"
          >
            {t('hero.cta_primary')}
            <i className="ri-arrow-right-line ml-2" />
          </Link>
          <Link
            to="/category/sports"
            className="w-full sm:w-auto px-8 py-3 text-sm font-medium text-background-50 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm border border-background-50/30 rounded-md transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta_secondary')}
          </Link>
        </div>
      </div>
    </section>
  );
}